import React, {useCallback} from "react";

export const useCheckboxOnChangeValue = (fun?: (value: any) => void) => useCallback(({ target: { checked }}: React.ChangeEvent<HTMLInputElement>) => {
  if (fun) fun(checked);
}, [fun]);
